module.exports = __webpack_public_path__ + "img/grp03.8c5f25c4.png";